/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Waffo_Private_KeyInputs */

const en_admin_settings_fields_waffo_private_key = /** @type {(inputs: Admin_Settings_Fields_Waffo_Private_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Private Key`)
};

/**
* | output |
* | --- |
* | "API Private Key" |
*
* @param {Admin_Settings_Fields_Waffo_Private_KeyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_waffo_private_key = /** @type {((inputs?: Admin_Settings_Fields_Waffo_Private_KeyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Waffo_Private_KeyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_waffo_private_key(inputs)
});
export { admin_settings_fields_waffo_private_key as "admin.settings.fields.waffo_private_key" }